import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Element, scroller } from "react-scroll";
import firebase from "firebase/compat/app";

const Chapter5_4 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was ist die Hauptaufgabe eines Mobile Device Management (MDM)-Systems?",
      options: [
        {
          value: "A",
          label:
            "Die Verwaltung aller Endpunkte, einschließlich Desktops, IoT-Geräten und Netzwerksensoren.",
        },
        {
          value: "B",
          label:
            "Die Verwaltung, Sicherung und Überwachung mobiler Geräte, wie Smartphones und Tablets.",
        },
      ],
      correct: "B",
    },
    {
      question:
        "Frage 2: Welche zusätzliche Funktion bietet Enterprise Mobility Management (EMM) im Vergleich zu MDM?",
      options: [
        {
          value: "A",
          label:
            "Die Verwaltung von Apps und Daten unabhängig vom Gerät (Mobile Application Management, MAM).",
        },
        {
          value: "B",
          label:
            "Die Integration von IoT-Geräten und stationären Computern in eine zentrale Plattform.",
        },
      ],
      correct: "A",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 5_4.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "5_4",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("5_4"),
            });
          console.log("Dokument aktualisiert mit Kapitel 5_4.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "5_4",
              completedChapters: ["5_4"],
            });
          console.log("Dokument erstellt mit Kapitel 5_4");
        }

        navigate("/5_5"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  5. Endpunktsicherheit
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Mobile Endpunktsicherheit
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">Kapitel 5: Endpunktsicherheit</h3>
          <h2 className="text-center p-3">Mobile Endpunktsicherheit</h2>
          <img
            src="/images/mobile-security.webp"
            alt="Mobile Security"
            style={{ position: "relative", maxWidth: "20%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h3 className="p-5">Mobile Security</h3>
          <p className="col-lg-11 mx-auto">
            Mobile Geräte ermöglichen Flexibilität und ortsunabhängiges
            Arbeiten. Mitarbeiter können auf E-Mails, Cloud-Dienste oder interne
            Netzwerke zugreifen – von unterwegs, aus dem Homeoffice oder im
            Büro. Die Gefahren sind mittlerweile bekannt: Die Geräte können leicht
            verloren gehen, sind häufiger Ziel von Phishing-Angriffen oder
            Malware und verbinden sich oft mit unsicheren Netzwerken wie
            öffentlichen WLANs.
            <br />
            <br />
            Die Vielfalt der Betriebssysteme und Plattformen ist eine weitere
            Herausforderung bei der Verwaltung mobiler Geräte. Die zwei
            dominierenden Systeme – Android und iOS – unterscheiden sich nicht
            nur in ihrer Architektur, sondern auch in den Möglichkeiten zur
            Sicherheitskontrolle.
            <br />
            <br />
            Android, als offenes System, bietet eine hohe Anpassungsfähigkeit,
            ist jedoch durch die Fragmentierung der Versionen und die
            Verfügbarkeit von Drittanbieter-Apps anfälliger für Malware und
            Sicherheitslücken.
            <br />
            <br />
            Im Gegensatz dazu bietet iOS durch seine geschlossene Architektur
            und strengen App-Kontrollen ein höheres Grundmaß an Sicherheit,
            lässt jedoch weniger Spielraum für unternehmensspezifische
            Anpassungen.
            <br />
            <br />
            Dazu kommt die fortlaufende Weiterentwicklung der Betriebssysteme.
            Regelmäßige Updates und Patches sind notwendig, um bekannte
            Sicherheitslücken zu schließen. Dennoch kann es in
            Unternehmensumgebungen vorkommen, dass Geräte mit unterschiedlichen
            Versionen eines Betriebssystems betrieben werden, was die
            Implementierung einheitlicher Sicherheitsrichtlinien erschwert.
          </p>

          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Die Verwaltung mobiler Endgeräte mit unterschiedlichen
            Betriebssystemen stellt Unternehmen vor spezifische
            Herausforderungen. Laut Statista 2024 dominiert Android den globalen
            Markt dabei mit einem Anteil von etwa 72%, während iOS rund 28%
            hält.
          </p>
        </div>
      </div>

      <div className="grey-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Mobile Device Management (MDM)</h3>
            <p className="col-lg-11 mx-auto">
              Das <strong> Mobile Device Management (MDM) </strong>{" "}
              bietet Unternehmen eine Plattform, über die mobile Geräte registriert,
              überwacht und abgesichert werden können. So können beispielsweise
              verschlüsselte Datenübertragungen erzwungen, Geräte bei Verlust
              oder Diebstahl aus der Ferne gesperrt oder sensible Daten gelöscht
              werden, um potenzielle Schäden zu minimieren. MDM ermöglicht die
              Trennung beruflicher von privaten Daten und gewährleistet damit
              den Schutz sensibler Daten und unterstützt die Einhaltung
              gesetzlicher Vorgaben.
              <br />
              <br />
              Ein Mobile Device Management (MDM)-System vereinfacht die
              Verwaltung mobiler Geräte und schützt Unternehmensdaten effektiv.
              Hier sind die wichtigsten Funktionen:
            </p>
            <h5 className="pt-5">
              <strong>Geräteverwaltung</strong>
            </h5>

            <p className="col-lg-11 mx-auto">
              MDM registriert, konfiguriert und überwacht Geräte, die auf
              Unternehmensressourcen zugreifen. Es stellt sicher, dass
              Sicherheitsrichtlinien wie Verschlüsselung und aktuelle Updates
              eingehalten werden. Abweichungen können automatisch erkannt und
              Maßnahmen wie Warnungen oder Netzwerksperren ausgelöst werden.
            </p>

            <h5 className="pt-5">
              <strong>Richtliniendurchsetzung</strong>
            </h5>

            <p className="col-lg-11 mx-auto">
              MDM erzwingt die Einhaltung von Sicherheitsvorgaben, z. B. durch
              Passwortrichtlinien, automatische Updates und die Sperrung
              unsicherer Geräte. So werden bekannte Schwachstellen vermieden und
              die Datensicherheit gewährleistet.
            </p>
            <h5 className="pt-5">
              <strong>Fernzugriff</strong>
            </h5>

            <p className="col-lg-11 mx-auto">
              Bei Verlust oder Diebstahl ermöglicht MDM das Sperren oder Löschen
              von Unternehmensdaten aus der Ferne, ohne private Daten zu
              beeinflussen – ein wichtiger Vorteil in BYOD-Umgebungen. Zudem
              können Standorte ermittelt werden, um gestohlene Geräte
              wiederzufinden.
            </p>

            <h5 className="pt-5">
              <strong>App-Management</strong>
            </h5>

            <p className="col-lg-11 mx-auto">
              Mit MDM lassen sich Apps kontrollieren, bereitstellen und
              aktualisieren. Genehmigte Apps können festgelegt, unsichere
              Anwendungen blockiert und veraltete Versionen automatisch entfernt
              werden, um Sicherheitsrisiken zu minimieren.
            </p>
            <h5 className="pt-5">
              <strong>Verschlüsselung der Daten </strong>
            </h5>

            <p className="col-lg-11 mx-auto">
              MDM ermöglicht die durchgängige Verschlüsselung aller auf mobilen
              Geräten gespeicherten Unternehmensdaten. Selbst wenn ein Gerät
              verloren geht oder gestohlen wird, bleiben die Informationen vor
              unbefugtem Zugriff geschützt.
            </p>
            <h5 className="pt-5">
              <strong>
                {" "}
                Trennung von privaten und beruflichen Daten durch
                Containerisierung
              </strong>
            </h5>

            <p className="col-lg-11 mx-auto">
              Um Datenlecks zu vermeiden, trennt MDM private von beruflichen
              Daten. Mit der Containerisierung werden berufliche Apps und Daten
              in einer isolierten Umgebung auf dem Gerät gespeichert. Diese
              Trennung stellt sicher, dass persönliche Anwendungen keinen
              Zugriff auf Unternehmensressourcen erhalten und umgekehrt.
            </p>

            <h5 className="pt-5">
              <strong> Geofencing: Standortbasierte Einschränkungen</strong>
            </h5>

            <p className="col-lg-11 mx-auto">
              Mit Geofencing können bestimmte Funktionen oder Zugriffe auf
              Unternehmensressourcen standortbasiert eingeschränkt werden.
              Beispielsweise kann der Zugriff auf sensible Daten nur innerhalb
              des Büros oder eines definierten geografischen Bereichs erlaubt
              sein, um Missbrauch außerhalb sicherer Zonen zu verhindern.
            </p>

            <h5 className="pt-5">
              <strong>Netzwerkschutz</strong>
            </h5>

            <p className="col-lg-11 mx-auto">
              MDM aktiviert automatisch VPNs bei unsicheren Netzwerken, um
              Datenverkehr zu verschlüsseln und unbefugten Zugriff zu
              verhindern. Zusätzlich können gefährliche Netzwerke blockiert
              werden, was die Sicherheit mobiler Geräte auch außerhalb des
              Unternehmens erhöht.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Der globale Markt für Mobile Device Management wurde 2024 auf 12,15 Milliarden US-Dollar geschätzt und soll bis 2032 auf 81,72
              Milliarden US-Dollar anwachsen, was einer durchschnittlichen
              jährlichen Wachstumsrate (CAGR) von 26,5% entspricht. (Fortune
              Business Insights)
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container p-5">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">
              Enterprise Mobility Management (EMM): Erweiterung von MDM
            </h3>
            <Element name="emm">
              <p className="col-lg-11 mx-auto">
                Während MDM sich auf die{" "}
                <strong> Verwaltung und Absicherung von Geräten </strong>{" "}
                konzentriert, geht das Enterprise Mobility Management (EMM) über
                die reine Geräteverwaltung hinaus und umfasst zusätzlich die{" "}
                <strong>Verwaltung von Apps, Daten und Identitäten. </strong>{" "}
                EMM ist demnach eine Erweiterung von MDM und bietet zusätzliche
                Funktionen:
                <br />
                <br />
                <strong> Mobile Application Management (MAM): </strong>
                EMM ermöglicht die Verwaltung von Apps unabhängig vom gesamten
                Gerät. Unternehmen können Apps zentral bereitstellen,
                aktualisieren und gleichzeitig kontrollieren, welche Anwendungen auf Geräten
                genutzt werden dürfen. Dies ist besonders wichtig bei
                BYOD-Geräten, da berufliche Apps von privaten Aktivitäten
                getrennt bleiben.
                <br />
                <br />
                <strong> Inhaltsverwaltung: </strong>
                Mit EMM können sensible Unternehmensdaten geschützt und
                Zugriffsrechte gesteuert werden. Beispielsweise lässt sich
                verhindern, dass Dokumente auf unsicheren Cloud-Diensten
                gespeichert oder an unautorisierte Empfänger weitergeleitet
                werden.
                <br />
                <br />
                <strong>Richtliniendurchsetzung: </strong>EMM bietet erweiterte
                Möglichkeiten, Sicherheitsrichtlinien für Apps, Daten und Geräte
                zentral durchzusetzen. Es sorgt dafür, dass nicht nur die Geräte
                sondern auch die Anwendungen (Apps, Software usw. ) den
                Unternehmensanforderungen entsprechen.
                <br />
                <br />
                Darüber hinaus bietet das EMM eine{" "}
                <strong> effiziente Verwaltung großer Geräteflotten, </strong>
                indem es IT-Teams ermöglicht, alle mobilen Geräte und deren
                Daten zentral zu steuern. Diese zentrale Verwaltung reduziert
                den Administrationsaufwand erheblich und gewährleistet eine
                konsistente Sicherheitsstrategie.
              </p>
            </Element>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-10 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Ende Fragenteil */}
      </div>
    </div>
  );
};

export default Chapter5_4;
